"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isArray_1 = __importDefault(require("lodash/isArray"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../app-reduxs/app/slice"));
const IC_Err_Calender_1 = __importDefault(require("../../assets/icons/IC_Err_Calender"));
const IconCheckModal_1 = __importDefault(require("../../assets/icons/IconCheckModal"));
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const CustomToast = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const isSuccessToast = (0, react_redux_1.useSelector)((state) => state.appReducer.isSuccessToast);
    const toast = (0, react_redux_1.useSelector)((state) => state.appReducer.toast);
    const toastAnim = (0, react_1.useRef)(new react_native_1.Animated.Value(0)).current;
    const refTimeout = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        if (toast) {
            clearTimeout(refTimeout.current);
            react_native_1.Animated.timing(toastAnim, {
                toValue: 1,
                duration: 0,
                useNativeDriver: true,
            }).start();
            refTimeout.current = setTimeout(() => {
                slideOut();
                clearTimeout(refTimeout.current);
            }, 2000);
        }
    }, [toast]);
    const slideOut = () => {
        react_native_1.Animated.spring(toastAnim, {
            toValue: 0,
            useNativeDriver: true,
        }).start(() => {
            dispatch(slice_1.default.actions.hideToast());
        });
    };
    const translateX = toastAnim.interpolate({
        inputRange: [0, 1],
        outputRange: [100, 0]
    });
    if (!toast)
        return null;
    return (react_1.default.createElement(react_native_1.View, { style: [
            styles.container, {
                top: inset.top + (0, scale_1.scale)(16),
            }
        ] }, (0, isArray_1.default)(toast) ?
        toast.map((message, index) => (react_1.default.createElement(react_native_1.Animated.View, { key: index, style: [
                styles.view,
                !isSuccessToast && {
                    backgroundColor: '#D32F2F'
                },
                {
                    transform: [{ translateX }],
                    opacity: toastAnim,
                    marginBottom: (0, scale_1.scale)(8),
                }
            ] },
            isSuccessToast ?
                react_1.default.createElement(IconCheckModal_1.default, null)
                :
                    react_1.default.createElement(IC_Err_Calender_1.default, null),
            react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles.text }, message))))
        :
            react_1.default.createElement(react_native_1.Animated.View, { style: [
                    styles.view,
                    !isSuccessToast && {
                        backgroundColor: '#D32F2F'
                    },
                    {
                        transform: [{ translateX }],
                        opacity: toastAnim
                    }
                ] },
                isSuccessToast ?
                    react_1.default.createElement(IconCheckModal_1.default, null)
                    :
                        react_1.default.createElement(IC_Err_Calender_1.default, null),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles.text }, toast))));
};
exports.default = CustomToast;
const styles = react_native_1.StyleSheet.create({
    container: {
        position: 'absolute',
        left: 0,
        right: 0,
        paddingHorizontal: (0, scale_1.scale)(16),
        overflow: 'hidden',
        zIndex: 100,
    },
    view: {
        width: '100%',
        flexDirection: "row",
        alignItems: "center",
        borderRadius: (0, scale_1.scale)(99),
        paddingVertical: (0, scale_1.scale)(8),
        paddingHorizontal: (0, scale_1.scale)(12),
        backgroundColor: "#44A06B",
    },
    text: {
        flex: 1,
        marginLeft: (0, scale_1.scale)(4),
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        textAlign: "center",
        color: '#FEFEFE'
    }
});
